export default "__VITE_PUBLIC_ASSET__45359e32__"